import { jsx as r } from "react/jsx-runtime";
import i from "classnames";
import { useMemo as c } from "react";
import o from "./index.es655.js";
import { useScreenZoomSize as n } from "./index.es589.js";
import { BodyText as p } from "./index.es505.js";
const d = "label", u = ({ color: m, children: s, testId: l = d }) => {
  const e = n(), t = c(() => e === "max", [e]), a = i(o.label, o[`label--color-${m}`], {
    [o["label--zoomed"]]: t
  });
  return /* @__PURE__ */ r("div", { className: a, "data-testid": l, children: /* @__PURE__ */ r(p, { color: "primary", children: s }) });
};
export {
  d as LABEL_DEFAULT_TESTID,
  u as Label
};
//# sourceMappingURL=index.es67.js.map
